/**
 * SEO component that queries for data with
 *  Gatsby's useStaticQuery React hook
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React, { useState } from "react";
import PropTypes from "prop-types";
import Helmet from "react-helmet";
import { useTranslation, I18nContext } from "next-i18next";
const siteUrl = require("@/config/siteConfig").siteUrl;
const languages = require("@/config/siteConfig").languages.filter(
  (lang) => lang !== `en`
);

const { site } = require("@/config/siteConfig");
const getDescription = (coin, description, fallbackDesc, seoDesc) => {
  if (coin !== undefined && description) {
    return `${seoDesc}`;
  } else if (coin === undefined && description) {
    return `${fallbackDesc} ${description}`;
  } else return fallbackDesc;
};

function Seo({
  description,
  meta = [],
  title = site.siteMetadata.title,
  image,
  hashtags,
  isguide = true,
  coin,
  langContext,
}) {
  const hashTagString = require("@/utils/hashTagUtils").hashtagsToString;
  const { t } = useTranslation("newguide");

  const seoDesc =
    coin !== undefined && description && isguide
      ? t("articleTitle", { symbol: coin.symbol, name: coin.name })
      : "";
  const metaDescription = getDescription(
    coin,
    description,
    site.siteMetadata.description,
    seoDesc
  );
  const imgUrl = image ? image : `${siteUrl}/banner.png`;

  const titleHashtags = title + " " + hashTagString(hashtags);

  const [lang, setLang] = useState(langContext.i18n.language);
  // const languages = langContext.i18n.languages.filter((lang) => lang !== `en`);
  const canonicalPath = `${langContext.siteUrl}${langContext.originalPath}`;

  return (
    <Helmet
      meta={[
        {
          name: `ir-site-verification-token`,
          content: `1670987975`,
        },
        {
          name: `description`,
          content: metaDescription,
        },
        {
          property: `og:url`,
          content: langContext.siteUrl + langContext.path,
        },
        {
          property: `og:title`,
          content: title,
        },
        {
          property: `og:description`,
          content: metaDescription,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          property: `og:image`,
          content: imgUrl,
        },
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          name: `twitter:creator`,
          content: site.siteMetadata.author,
        },
        {
          name: `twitter:title`,
          content: titleHashtags,
        },
        {
          name: `twitter:description`,
          content: metaDescription,
        },
        {
          name: `twitter:image`,
          content: imgUrl,
        },
        {
          name: `p:domain_verify`,
          content: `b91abdca0d08b857e9103e10c08189d5`,
        },
      ].concat(meta)}
    >
      {/*{isguide && (*/}
      {/*  <script type="application/ld+json">*/}
      {/*    {JSON.stringify(schema, null, 2)}*/}
      {/*  </script>*/}
      {/*)}*/}
      {isguide && (
        <link
          rel="alternate"
          hrefLang={`x-default`}
          href={`${site.siteMetadata.siteUrl}${coin.url_slug}`}
        />
      )}
      {/*{isguide &&*/}
      {/*  languages.map((language, index) => (*/}
      {/*    <link*/}
      {/*      rel="alternate"*/}
      {/*      hrefLang={language}*/}
      {/*      key={index}*/}
      {/*      href={`${site.siteUrl}/${language}${coin.url_slug}`}*/}
      {/*    />*/}
      {/*  ))}*/}
      {/*{isguide &&*/}
      {/*  additionalLanguages.map((language, index) => (*/}
      {/*    <link*/}
      {/*      rel="alternate"*/}
      {/*      hrefLang={language}*/}
      {/*      key={`${language}-${index}`}*/}
      {/*      href={`${getLanguageSubdomain(siteUrl, language)}${coin.url_slug}`}*/}
      {/*    />*/}
      {/*  ))}*/}
      <html lang={lang} dir={langContext.i18n.dir(lang)} />
    </Helmet>
  );
}

Seo.propTypes = {
  description: PropTypes.string,
  lang: PropTypes.string,
  meta: PropTypes.arrayOf(PropTypes.object),
  title: PropTypes.string.isRequired,
};

export default Seo;
